// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1ub7A","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1W04C"};